module.exports = __webpack_public_path__ + "img/001.0fabb53e.jpg";